/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Done_Next_IntegrationsInputs */

const cs_import_done_next_integrations = /** @type {(inputs: Import_Done_Next_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpět na integrace`)
};

const en_import_done_next_integrations = /** @type {(inputs: Import_Done_Next_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to integrations`)
};

/**
* | output |
* | --- |
* | "Back to integrations" |
*
* @param {Import_Done_Next_IntegrationsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_done_next_integrations = /** @type {((inputs?: Import_Done_Next_IntegrationsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Done_Next_IntegrationsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_done_next_integrations(inputs)
	return cs_import_done_next_integrations(inputs)
});